<p class="grid-caption" *ngIf="model.dis!=4 && model.tit"><strong class="grid-title">{{model.tit}}</strong> {{model.dsc ? ' - ' + model.dsc: ''}}</p>
<div [id]="model.id" class="chart-box" [attr.style]="(model.ssty||'')"></div>